// §25.8 / §9.1 — Conquest as an in-process app. Gated (D-200); manifest only (D-247).
//
// A **factory** since M30: Conquest holds a D-059 capability, because `HangarAPI` carries nothing
// social (§4.1) and a networked game needs a session. Cascade's shape exactly — the grant is one
// readable line in `App.tsx`, and an external app can never obtain one.
import type { InProcessApp, PlayShellAccess } from '@hangar/shared';
import { createLazyApp } from '@/gamekit/lazy';

export function createConquestApp(play: PlayShellAccess): InProcessApp {
  return createLazyApp<{ play: PlayShellAccess }>({
    app: {
      id: 'conquest',
      name: 'Conquest',
      icon: { glyph: 'globe', hue: 205 },
      keywords: ['risk', 'strategy', 'territory', 'dice', 'game', 'arcade'],
      category: 'Arcade',
      // §29.1 (D-369) — the sub-group header this title sits under in the launcher and the Store.
      group: 'Boards',
      requiresAuth: true,
      // The widest window in the Arcade, and it needs to be: forty-two territories and a phase panel
      // do not fold. The minimum is set where the army badges are still readable rather than where
      // the layout technically survives.
      window: { width: 1040, height: 760, minWidth: 720, minHeight: 560, multiWindow: false },
      jumpList: [
        { id: 'new-game', label: 'New game' },
        { id: 'end-turn', label: 'End turn' },
      ],
    },
    load: () => import('./Conquest'),
    props: { play },
  });
}
